import axios from 'axios'

export const createPortalSession = async () => {
    try {
        const response = await axios.post(
            `${process.env.API_URL}/stripe/create-portal-session`
        )
        return response.data
    } catch (error) {
        throw new Error(
            error.response ? error.response.data.message : 'Network error'
        )
    }
}
